<template>
    <div class="ImportFilters flex row-center">
        <div
            v-for="({ name, type, placeholder, options }) in filters"
            :key="`filter-${name}`"
            class="FormCell"
        >
            <template v-if="type === 'select'">
                <WSelect
                    :name="name"
                    :value="value[name]"
                    :options="options"
                    :placeholder="placeholder"
                    @input="handleInput(name, $event)"
                />
            </template>
            <template v-else-if="type === 'date'">
                <WDatepicker
                    :name="name"
                    :value="value[name]"
                    :placeholder="placeholder"
                    mode="range"
                    @input="handleInput(name, $event)"
                />
            </template>
            <template v-else-if="type === 'switch'">
                <WSwitch
                    :name="name"
                    :value="value[name]"
                    @input="handleInput(name, $event)"
                />
            </template>
            <template v-else>
                <WInput
                    :name="name"
                    :type="type"
                    :value="value[name]"
                    :placeholder="placeholder"
                    @input="handleInput(name, $event)"
                />
            </template>
        </div>
        <WButton
            color="primary"
            class="ml-1"
            @click="$emit('onSubmit')"
        >
            {{ $t('general.apply') }}
        </WButton>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'ImportFilters',
    props: {
        value: VueTypes.any.def({}),
        filters: VueTypes.arrayOf(VueTypes.shape({
            name: VueTypes.string,
            value: VueTypes.string,
            placeholder: VueTypes.string,
            options: VueTypes.array,
        }).loose),
    },
    computed: {
        dirty () {
            return !!Object.values(this.value).filter(Boolean).length
        },
    },
    methods: {
        handleInput (name, value) {
            this.$emit('input', {
                ...(this.value || {}),
                [name]: value,
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.FormCell {
    width: 165px;

    & + .FormCell {
        margin-left: 15px;
    }

    .WDatepicker::v-deep .Input {
        margin-bottom: 0;
    }
}
</style>
